import { render, staticRenderFns } from "./associaNazionalita.vue?vue&type=template&id=e5202978&"
import script from "./associaNazionalita.vue.ts?vue&type=script&lang=ts&"
export * from "./associaNazionalita.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports